module.exports = __webpack_public_path__ + "static/hugo2-62ee7626fd5dd4703991735c1f17074b.jpg";